// extracted by mini-css-extract-plugin
export default {"customHeader":"Collpase_customHeader__-f9j6"};